export default "__VITE_ASSET__DOlrOMCT__"